import { Injectable } from '@angular/core';
import { RuntimeEnvironmentService } from '@app/core/runtime-environment.service';

@Injectable()
export class RavenInstallService {

  constructor(
    protected runtimeEnvironmentService: RuntimeEnvironmentService,
  ) {
    this.installRaven();
    // this.authService.user.subscribe(user => {
    //   if (Raven.setUserContext) {
    //     // raven-js
    //     Raven.setUserContext(user);
    //   } else {
    //     // raven-node
    //     Raven.mergeContext({ user });
    //   }
    // });
  }

  protected installRaven() {
    // Raven.install() must be called even when DSN is not set,
    // See: https://github.com/getsentry/raven-node/issues/281#issuecomment-291621174
    Raven
      .config(this.runtimeEnvironmentService.ravenDsn || false, {
        release: this.runtimeEnvironmentService.gitCommitSha,
        serverName: this.runtimeEnvironmentService.serverName,
        autoBreadcrumbs: {
          'xhr': true,       // XMLHttpRequest
          'console': true,   // console logging
          'dom': true,       // DOM interactions, i.e. clicks/typing
          'location': true,  // url changes, including pushState/popState
          'http': true,
        },
      })
      .install();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/raven/raven-install.service.ts